import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("parentia_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 402 = accès verrouillé : on renvoie vers l'abonnement plutôt qu'une erreur opaque.
// Exception : les contes audio (crédits de parrainage) sont gérés dans le lecteur.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const url = error?.config?.url || "";
    const isAudioQuota = url.includes("/audio");
    if (
      error?.response?.status === 402 &&
      !isAudioQuota &&
      !window.location.pathname.startsWith("/abonnement")
    ) {
      toast.error(error.response.data?.detail || "Accès verrouillé — débloque Kynoria pour continuer.");
      window.location.href = "/abonnement";
    }
    return Promise.reject(error);
  }
);

export default api;
